import React, { useState } from "react";
import { beauticians, stats } from "../mock";
import { Star, MapPin, ChevronRight } from "lucide-react";
import { Button } from "./ui/button";

const scrollToServices = () => document.getElementById("services")?.scrollIntoView({ behavior: "smooth" });

const BeauticianCard = ({ b }) => {
  const [expanded, setExpanded] = useState(false);
  const shown = expanded ? b.reviews : b.reviews.slice(0, 2);
  return (
    <div className="bg-white rounded-2xl ring-1 ring-black/5 shadow-sm hover:shadow-lg transition-shadow overflow-hidden flex flex-col">
      <div className="p-5 flex items-center gap-4 bg-secondary/40">
        <div className="w-16 h-16 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-display text-2xl font-bold shrink-0">
          {b.name[0]}
        </div>
        <div className="min-w-0">
          <h3 className="font-semibold text-gray-900 text-lg">{b.name}</h3>
          <p className="text-xs text-gray-500 flex items-center gap-1 mt-0.5 truncate">
            <MapPin className="w-3.5 h-3.5 shrink-0" /> {b.location}
          </p>
          <div className="flex items-center gap-2 mt-1.5">
            <span className="flex items-center gap-1 bg-primary text-primary-foreground text-xs font-bold px-2 py-0.5 rounded">
              <Star className="w-3 h-3 fill-white" /> {b.rating}
            </span>
            <span className="text-xs text-gray-500">({b.ratings} ratings · {b.fiveStar} × 5★)</span>
          </div>
        </div>
      </div>
      <div className="p-5 space-y-4 flex-1">
        {shown.map((r, i) => (
          <div key={i} className="border-b border-gray-100 last:border-0 pb-3 last:pb-0">
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 rounded-full bg-secondary text-primary flex items-center justify-center text-xs font-bold">
                {r.by[0]}
              </div>
              <span className="text-sm font-medium text-gray-800">{r.by}</span>
              <span className="ml-auto flex items-center gap-0.5">
                {Array.from({ length: r.stars }).map((_, k) => <Star key={k} className="w-3 h-3 fill-accent text-accent" />)}
              </span>
            </div>
            <p className="text-sm text-gray-600 mt-1.5">{r.text}</p>
          </div>
        ))}
      </div>
      <div className="px-5 pb-5 flex items-center gap-3">
        <Button onClick={scrollToServices} className="flex-1 bg-primary hover:bg-primary/90 rounded-full h-10 font-semibold">
          Book {b.name.split(" ")[0]}
        </Button>
        <button onClick={() => setExpanded(!expanded)} className="text-sm text-primary font-medium flex items-center hover:underline">
          {expanded ? "Less" : "More"} <ChevronRight className={`w-4 h-4 transition-transform ${expanded ? "rotate-90" : ""}`} />
        </button>
      </div>
    </div>
  );
};

const TopBeauticians = () => {
  return (
    <section id="beauticians" className="py-14 md:py-20 scroll-mt-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-12">
        <div className="text-center mb-4">
          <p className="text-primary font-semibold tracking-wide uppercase text-sm">Meet Our Experts</p>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-gray-900 mt-2">Top Rated Beauticians</h2>
          <p className="text-gray-600 mt-3">
            {stats.professionals}+ certified women beauty professionals serving across Gurugram
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
          {beauticians.map((b) => <BeauticianCard key={b.name} b={b} />)}
        </div>
      </div>
    </section>
  );
};

export default TopBeauticians;
